<template>
<!-- 신규 시나리오 -->
  <div   class="cate_wrap_w">
    <dl>
      <dt>시나리오 이름<span class="essential">*</span></dt>
      <dd>
        <aicc-text-field v-model="scenarioRequestAsk.scenarioName" :disabled="false" :clearable="false" :readonly="false" placeholder="시나리오 이름을 입력해주세요." :width="650" :counter="scenarioNameMaxLength" :rules="validateRule" ref="scenarioName" @blur="onBlurTrimValidate" @input="onInput"/>
      </dd>
    </dl>
    <dl>
      <dt>시나리오 설명</dt>
      <dd>
        <aicc-text-field v-model="scenarioRequestAsk.summary" :disabled="false" :clearable="false" :readonly="false" placeholder="시나리오 설명을 작성해주세요." :width="650" :counter="summaryMaxLength" :rules="summaryValidateRule" ref="summary" @blur="onBlurTrimValidateSummary"/>
      </dd>
    </dl>
    <dl>
      <dt>기타 요청사항</dt>
      <dd>
        <aicc-text-field v-model="scenarioRequestAsk.description" :disabled="false" :clearable="false" :readonly="false" placeholder="기타 요청사항이 있다면 작성해주세요." :width="650" :counter="descriptionMaxLength" :rules="descriptionValidateRule" ref="description" @blur="onBlurTrimValidateDescription"/>
      </dd>
    </dl>
    <dl>
      <dt>상담 매뉴얼 & 상담 스크립트<span class="essential">*</span></dt>
      <dd style="width:912px">
        <!-- 첨부파일 -->
        <file-attacher ref="fileAttacher" :attachRestrictionSize="attachRestrictionSize" :attachRestrictionQuantity="attachRestrictionQuantity" :fileUploadExt="fileUploadExt" />
        <div class="info" style="width:912px">
          <div style="float:right;">
            <ur-button shape="hyperlink" icon="download" @click="onClickManualDownload()">상담 매뉴얼 샘플 다운로드</ur-button>
            <ur-button shape="hyperlink" icon="download" @click="onClickScriptDownload()">상담 스크립트 샘플 다운로드</ur-button>
          </div>
          <p class="txt_desc">* <strong>상담 매뉴얼</strong>과 <strong>상담 스크립트</strong>를 모두 업로드 해주세요.</p>
          <p class="txt_desc">* 업로드 가능한 파일 확장자는 {{ fileUploadExt }}입니다.</p>
        </div>
      </dd>
    </dl>
    <!-- 스낵바 -->
    <ur-snackbar ref="snackbar" :duration="3000"/>
  </div>
</template>

<script>
import BasePage from '~cm/components/BasePage';
import CMP_AID_00005 from './CMP_AID_00005';

export default {
  name: 'CMP_AID_00004', // eslint-disable-line vue/name-property-casing
  components: {
    fileAttacher: CMP_AID_00005,
  },
  extends: BasePage,
  props: {
    parentPageId: { type: String, required: true },
    scenarioNameItems: { type: Array, default: () => [] },
  },
  data() {
    return {
      // 신규 시나리오
      scenarioRequestAsk: {
        scenarioName: '',
        summary: '',
        description: '',
      },

      // 첨부파일
      attachRestrictionSize: 100, // MB
      attachRestrictionQuantity: 5,
      fileUploadExt: 'ppt,pptx,doc,docx,txt,csv,xls,xlsx,xlsm,pdf,png,jpg,hwp,hwpx,zip',

      // validator
      validateRule: [
        (v) => !!v || '필수 입력 항목입니다.',
        (v) => this.scenarioNameCheckflag || '기존에 사용하지 않은 시나리오 이름을 입력해주세요.',
        (v) => aiccUtils.getStringByteSize(this.scenarioRequestAsk.scenarioName) <= this.scenarioNameMaxLength || `최대 ${this.scenarioNameMaxLength}byte까지 입력 가능합니다.`,
      ],
      summaryValidateRule: [
        (v) => aiccUtils.getStringByteSize(this.scenarioRequestAsk.summary) <= this.summaryMaxLength || `최대 ${this.summaryMaxLength}byte까지 입력 가능합니다.`,
      ],      
      descriptionValidateRule: [
        (v) => aiccUtils.getStringByteSize(this.scenarioRequestAsk.description) <= this.descriptionMaxLength || `최대 ${this.descriptionMaxLength}byte까지 입력 가능합니다.`,        
      ],
      scenarioNameCheckflag: true,
      scenarioNameMaxLength: 70, // byte
      summaryMaxLength: 100, // byte
      descriptionMaxLength: 300, // byte

      // 다운로드
      fileType: 'image/jpeg',
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      this.getFileUploadRestriction();
    },

    // 상담 매뉴얼 샘플 다운로드
    onClickManualDownload() {
      http.request(this.parentPageId, 'DTS_AIM_00011', {
        path: {
          'file-id': '1A959008-57D1-11EC-A59F-0050569345CE',
        },
      }).then(res => {
        aiccUtils.fileDownload.downloadBase64(res.data.file.file, res.data.file.fileName, this.fileType);
      });
    },

    // 상담 스크립트 샘플 다운로드
    onClickScriptDownload() {
      http.request(this.parentPageId, 'DTS_AIM_00011', {
        path: {
          'file-id': '45BBCFD8-57E0-11EC-A59F-0050569345CE',
        },
      }).then(res => {
        aiccUtils.fileDownload.downloadBase64(res.data.file.file, res.data.file.fileName, this.fileType);
      });
    },

    // 신규 시나리오 신청
    onBlurTrimValidate() {
      this.scenarioRequestAsk.scenarioName = this.scenarioRequestAsk.scenarioName.trim();
      this.$nextTick(() => {
        this.scenarioNameCheckflag = !this.scenarioNameItems.includes(this.scenarioRequestAsk.scenarioName);
        this.$refs.scenarioName.validate();
      });
    },
    onBlurTrimValidateSummary() {
      this.scenarioRequestAsk.summary = this.scenarioRequestAsk.summary.trim();
      this.$nextTick(() => {
        this.$refs.summary.validate();
      });
    },
    onBlurTrimValidateDescription() {
      this.scenarioRequestAsk.description = this.scenarioRequestAsk.description.trim();
      this.$nextTick(() => {
        this.$refs.description.validate();
      });
    },
    onInput() {
      this.scenarioNameCheckflag = true;
    },

    request() {
      if (!this.$refs.scenarioName.isValid()) {
        return;
      }
      if (!this.$refs.summary.isValid()) {
        return;
      }
      if (!this.$refs.description.isValid()) {
        return;
      }

      if (this.$refs.fileAttacher.attachFileList.length === 0) {
        this.showSnackbar('파일 첨부는 필수입니다.');
        return;
      }

      // handle file changes
      const formData = new FormData();
      this.$refs.fileAttacher.attachFileList.forEach((fileInfo, index) => {
        formData.append('files', fileInfo.file);
      });

      formData.append('ask', new Blob([JSON.stringify(this.scenarioRequestAsk)], { type: 'application/json' }));

      http.request(this.parentPageId, 'DTS_AID_00020', {
        data: formData,
      }).then(res => {
        if (res.data.reply.code === '0000') {
          this.$emit('complete');
        } else if (res.data.reply.code === '4001') { // 업로드할 수 없는 파일 형식입니다.
          this.showSnackbar(res.data.reply.korMsg);
        } else if (res.data.reply.code === '4002') { // 업로드할 수 있는 파일의 용량을 초과하였습니다.
          this.showSnackbar(res.data.reply.korMsg);
        } else if (res.data.reply.code === '4003') { // 업로드할 수 있는 파일의 개수를 초과하였습니다.
          this.showSnackbar(res.data.reply.korMsg);
        } else if (res.data.reply.code === '2003') { // 시나리오 이름 중복
          this.scenarioNameCheckflag = false;
          this.$refs.scenarioName.validate();
        } else {
          utils.aiccMessageBox('확인', res.data.reply.korMsg, '확인', null);
        }
      });
    },
    showSnackbar(message) {
      this.$nextTick(() => {
        this.$refs.snackbar.show({ text: message });
      });
    },

    // 첨부파일
    getFileUploadRestriction() {
      http.request(this.parentPageId, 'DTS_AID_00021', {
      }).then(res => {
        this.attachRestrictionSize = res.data.sizeLimit;
        this.attachRestrictionQuantity = res.data.quantityLimit;
        this.fileUploadExt = res.data.whiteList;
      });
    },
  },
};
</script>

<style scoped>
.txt_desc{
  font-size: 14px;
  line-height: 1.43;
  color: #333;
}
strong{
  font-size: 14px;
  font-weight: bold;
}
</style>
